<template>
  <section>
    <script type="application/ld+json" v-html="breadcrumbStructuredData"></script>
    <nav :aria-label="$t('Breadcrumb')" :class="['breadcrumb font-smaller', invert ? 'invert' : '']">
      <ol>
        <li v-for="(item, i) in filteredItems" :key="item.url_key ? item.url_key : item.path">
          <router-link v-if="item.url_key" :to="`${localizedUrl}/products/` + getPath(item.url_key)">
            <span>{{ item.name }}</span>
          </router-link>
          <router-link v-if="item.path" :to="`${localizedUrl}${item.path}`">
            <span>{{ item.name }}</span>
          </router-link>
        </li>
        <li v-if="lastItem && !this.short">
          <span aria-current="page">{{ lastItem.name }}</span>
        </li>
      </ol>
    </nav>
  </section>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  props: ['items', 'pagePosition', 'siblings-components', 'short', 'invert'],
  name: 'Breadcrumb',
  data() {
    return {
      baseUrl: 'https://www.zenith-watches.com'
    }
  },
  computed: {
    mappedItems() {
      return this.items && this.items.length ? this.items.map((item) => {
        // check if is acronym looking if it has a point after each letter
        const isAcronym = /\b(?:[A-Z]\.){2,}/.test(item.name)
        if (!isAcronym) {
          item.name = item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
        }
        return item
      }) : []
    },
    filteredItems() {
      return this.mappedItems.filter((x, i) => i !== this.mappedItems.length - 1 && x.include_in_menu !== 0 && !(this.short && i > 1))
    },
    lastItem() {
      return this.mappedItems[this.mappedItems.length - 1]
    },
    localizedUrl() {
      const { url } = currentStoreView()
      return url || ''
    },
    breadcrumbStructuredData() {
      const hasAlreadyHomepage = this.filteredItems.find(item => item.name === 'Homepage')
      const itemListElement = !hasAlreadyHomepage ? [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': `${this.baseUrl}${this.localizedUrl}/`,
            name: 'Home'
          }
        }
      ] : []
      const indexIncrement = hasAlreadyHomepage ? 1 : 2
      // Add filtered items
      this.filteredItems.forEach((item, index) => {
        const url = this.buildItemUrl(item)
        itemListElement.push({
          '@type': 'ListItem',
          position: index + indexIncrement,
          item: {
            '@id': `${this.baseUrl}${url}`,
            name: item.name === 'Homepage' ? 'Home' : item.name
          }
        })
      })

      // Add last item if it exists and not in short mode
      if (this.lastItem && !this.short) {
        itemListElement.push({
          '@type': 'ListItem',
          position: this.filteredItems.length + indexIncrement,
          item: {
            '@id': `${this.baseUrl}${this.$route.path}`,
            name: this.lastItem.name
          }
        })
      }

      return JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement
      })
    }
  },
  methods: {
    buildItemUrl(item) {
      let url = this.localizedUrl
      if (item.url_key) {
        url += `/products/${this.getPath(item.url_key)}`
      }
      return url
    },
    getPath(url_key) {
      return this.mappedItems.filter((x) => x.url_key === 'straps').length && url_key !== 'straps' ? 'straps-' + url_key : url_key
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.breadcrumb {
  position: absolute;
  z-index: 5;
  top: 2.5rem;
  left: 4rem;
  max-width: 45%;

  @include bp(max lg) {
    max-width: 100%;
    left: 2rem;
    top: 2rem;
  }
  @include bp(max md) {
    top: 2rem;
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {

      &:not(:first-child):before {
        font-size: em(14);
        content: '•';
        margin: 0 1rem;
        position: relative;
        top: 0.1rem;
        color: var(--zenith-theme-primary);
      }

      a {
        color: var(--zenith-theme-primary);

        &:hover,
        &:active,
        &:focus {
          opacity: 0.6;
        }
      }

      & > span {
        color: var(--zenith-theme-primary);
      }
    }
  }
  &.invert {
    filter: invert(1);
  }
}
</style>
